import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-modal";
import ReactDropzone from "react-dropzone";

import IconClose from "../../Icons/IconClose";
import IconUpload from "../../Icons/IconUpload";
import { toast } from "react-toastify";

import {
  setLogoSelector,
  setMaskSelector,
  resetLogoSelector,
  resetMaskSelector
} from "Actions";
import { uploadMediaFiles } from "Thunks";
import { getAllowedMediaTypes, getUserAllowedLanguages } from "Utils";

import styles from "./AddMedia.local.scss";
import _ from "i18n";

class AddMedia extends Component {
  close = () => {
    const { onRequestClose, resetMaskSelector, resetLogoSelector } = this.props;

    onRequestClose && onRequestClose();
    resetLogoSelector();
    resetMaskSelector();
  };

  renderOptions = () => {
    const {
      lng,
      selectedMask,
      selectedLogo,
      setMaskSelector,
      setLogoSelector,
      navCommunity
    } = this.props;
    const titleAttr = "title" + lng.charAt(0).toUpperCase() + lng.slice(1);
    const allowedMediaTypes = getAllowedMediaTypes(navCommunity);

    return (
      <div className={styles.options}>
        <label
          className={selectedLogo ? styles.selectedOption : ""}
          onClick={() => {
            if (allowedMediaTypes.length > 0) setLogoSelector({ isOpen: true });
          }}
        >
          <input
            type="radio"
            checked={!!selectedLogo}
            onClick={e => e.stopPropagation()}
          />
          {_("Add a logo")}
          {selectedLogo && (
            <span title={selectedLogo[titleAttr]}>
              {`(${selectedLogo[titleAttr]})`}
            </span>
          )}
        </label>
        <label
          className={selectedMask ? styles.selectedOption : ""}
          onClick={() => {
            if (allowedMediaTypes.length > 0) setMaskSelector({ isOpen: true });
          }}
        >
          <input
            type="radio"
            checked={!!selectedMask}
            onClick={e => e.stopPropagation()}
          />
          {_("Apply a mask")}
          {selectedMask && (
            <span title={selectedMask[titleAttr]}>
              {`(${selectedMask[titleAttr]})`}
            </span>
          )}
        </label>
      </div>
    );
  };

  onDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles && rejectedFiles.length > 0) {
      toast.error(
        <div class="flashMessage">
          <div class="flahMessage__icon">
            <i className="icotam-close-outline" />
          </div>
          <div className="flashMessage__body">
            <h5>{_("Error")}</h5>
            <div>
              <span>{_("Some files are invalid : ")}</span>
              <ul>
                {rejectedFiles.map(file => (
                  <li key={file.name}>{file.name}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      );
    }

    if (!acceptedFiles || acceptedFiles.length === 0) {
      return;
    }

    const {
      uploadMediaFiles,
      selectedMask,
      selectedLogo,
      selectedLogoSize,
      selectedLogoPosition,
      navCommunity
    } = this.props;

    let languages = getUserAllowedLanguages(navCommunity);

    uploadMediaFiles(
      acceptedFiles,
      null,
      selectedMask,
      selectedLogo,
      selectedLogoPosition,
      selectedLogoSize,
      languages
    );

    this.close();
  };

  getAcceptedTypes = () => {
    const { navCommunity } = this.props;
    const allowedMediaTypes = getAllowedMediaTypes(navCommunity);
    const acceptedTypes = [];

    if (allowedMediaTypes.includes("IMAGE")) {
      acceptedTypes.push("image/*");
    }

    if (allowedMediaTypes.includes("VIDEO")) {
      acceptedTypes.push("video/*");
    }

    if (allowedMediaTypes.includes("PDF")) {
      acceptedTypes.push("application/pdf");
    }

    if (allowedMediaTypes.includes("PPT")) {
      acceptedTypes.push(
        ...[
          "application/vnd.ms-powerpoint",
          "application/vnd.ms-powerpoint.addin.macroEnabled.12",
          "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
          "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
          "application/vnd.ms-powerpoint.template.macroEnabled.12",
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
          "application/vnd.openxmlformats-officedocument.presentationml.template"
        ]
      );
    }

    return acceptedTypes;
  };

  renderDropzone = () => {
    const { navCommunity } = this.props;
    const allowedMediaTypes = getAllowedMediaTypes(navCommunity);
    return (
      <ReactDropzone
        onDrop={this.onDrop}
        accept={this.getAcceptedTypes()}
        className={styles.dropzone}
        activeClassName={styles.dropzoneActive}
        rejectClassName={styles.dropzoneReject}
      >
        <IconUpload size={51} />

        <p className={styles.dropzoneTextLarge}>
          {_(
            "Drag and drop files here, or click to select the files to download."
          )}
        </p>

        <button>{_("Select files")}</button>

        <p className={styles.dropzoneTextSmall}>
          {_("Maximum upload file size: 8MB.")}
          {allowedMediaTypes.length > 0 && (
            <div>
              {_("Allowed medias: ")}
              {allowedMediaTypes.join(", ")}
            </div>
          )}
        </p>

        {allowedMediaTypes.length === 0 && (
          <div
            className={styles["dropzone--disabled"]}
            onClick={e => e.stopPropagation()}
          >
            {_("You are not allowed to add medias, please check the settings")}
          </div>
        )}
      </ReactDropzone>
    );
  };

  render() {
    const { isOpen } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={this.close}
        className={{
          base: styles.modalContent,
          afterOpen: styles.modalContentAfterOpen,
          beforeClose: styles.modalContentBeforeClose
        }}
        overlayClassName={{
          base: styles.modalOverlay,
          afterOpen: styles.modalOverlayAfterOpen,
          beforeClose: styles.modalOverlayBeforeClose
        }}
        closeTimeoutMS={300}
        contentLabel="Add media"
      >
        <div className={styles.modal}>
          <div className={styles.close} onClick={this.close}>
            <IconClose size={17} />
          </div>
          <div className={styles.body}>
            {this.renderOptions()}
            {this.renderDropzone()}
          </div>
        </div>
      </Modal>
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  lng: state.params.lng,
  navCommunity: state.auth.navCommunity,
  selectedMask: state.maskSelector.selectedMask,
  maskSelectorIsOpen: state.maskSelector.isOpen,
  selectedLogo: state.logoSelector.selectedLogo,
  selectedLogoPosition: state.logoSelector.selectedPosition,
  selectedLogoSize: state.logoSelector.selectedSize,
  logoSelectorIsOpen: state.logoSelector.isOpen
});

const mapDispatchToProps = dispatch => ({
  resetMaskSelector: () => dispatch(resetMaskSelector()),
  resetLogoSelector: () => dispatch(resetLogoSelector()),
  setMaskSelector: options => dispatch(setMaskSelector(options)),
  setLogoSelector: options => dispatch(setLogoSelector(options)),
  uploadMediaFiles: (
    files,
    docType,
    mask,
    logo,
    logoPosition,
    logoSize,
    languages
  ) =>
    dispatch(
      uploadMediaFiles(
        files,
        docType,
        mask,
        logo,
        logoPosition,
        logoSize,
        languages
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddMedia);



// WEBPACK FOOTER //
// ./src/components/Reveal/AddMedia/AddMedia.js